(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lamier-reference-header"] && !Shopify.designMode) return;
  try {
    
function lamierTimer(){document.querySelectorAll('.lr-timer').forEach(el=>{if(el.dataset.bound)return;el.dataset.bound='1';const tick=()=>{const n=Math.max(0,Math.floor((Date.parse(el.dataset.end)-Date.now())/1000));['days','hours','minutes','seconds'].forEach((k,i)=>{const v=[Math.floor(n/86400),Math.floor(n%86400/3600),Math.floor(n%3600/60),n%60][i];el.querySelector('[data-'+k+']').textContent=i?String(v).padStart(2,'0'):v;});};tick();const timer=setInterval(()=>{if(!el.isConnected)clearInterval(timer);else tick();},1000);});}lamierTimer();document.addEventListener('shopify:section:load',lamierTimer);document.addEventListener('click',e=>{const link=e.target.closest('.lr-cart'),drawer=document.querySelector('#cart-drawer');if(link&&drawer&&typeof drawer.open==='function'){e.preventDefault();drawer.open();}});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lamier-reference-product"] && !Shopify.designMode) return;
  try {
    
function initLamierProduct(){
 document.querySelectorAll('.lr-main').forEach(root=>{
  if(root.dataset.bound)return;root.dataset.bound='1';
  const form=root.querySelector('.lr-product-form'),slides=[...root.querySelectorAll('.lr-slide')],thumbs=[...root.querySelectorAll('[data-thumbnail]')];
  let colour=root.dataset.variantTitle,selected;
  function show(id){selected=id;slides.forEach(s=>{const active=s.dataset.imageId===id;s.hidden=!active;s.classList.toggle('is-selected',active);});thumbs.forEach(t=>{const active=t.dataset.thumbnail===id;t.classList.toggle('is-selected',active);t.setAttribute('aria-pressed',String(active));});}
  function setColour(name){colour=slides.some(s=>s.dataset.colour===name)?name:slides[0]?.dataset.colour;const visible=slides.filter(s=>s.dataset.colour===colour);thumbs.forEach(t=>t.hidden=t.dataset.colour!==colour);show(visible[0]?.dataset.imageId);}
  setColour(colour);
  root.addEventListener('change',e=>{
   if(!e.target.matches('.lr-variants input'))return;
   const input=e.target;form.querySelector('[name="id"]').value=input.value;
   root.querySelector('[data-colour-name]').textContent=input.dataset.displayTitle;
   root.querySelector('[data-price]').textContent=input.dataset.price;
   root.querySelector('[data-compare]').textContent=input.dataset.compare;
   setColour(input.dataset.title);const url=new URL(location.href);url.searchParams.set('variant',input.value);history.replaceState({},'',url);
  });
  root.addEventListener('click',e=>{
   const thumb=e.target.closest('[data-thumbnail]');if(thumb)show(thumb.dataset.thumbnail);
   const swatch=e.target.closest('[data-addon-variant]');
   if(swatch){e.preventDefault();const row=swatch.closest('.lr-addon');row.querySelector('input').value=swatch.dataset.addonVariant;row.querySelector('label>img').src=swatch.dataset.addonImage;row.querySelector('label>img').removeAttribute('srcset');row.querySelectorAll('[data-addon-variant]').forEach(b=>b.classList.toggle('is-selected',b===swatch));row.querySelector('i').textContent=swatch.dataset.name;}
  });
  let touchX;
  root.querySelector('.lr-slides').addEventListener('pointerdown',e=>touchX=e.clientX);
  root.querySelector('.lr-slides').addEventListener('pointerup',e=>{if(touchX===undefined||Math.abs(e.clientX-touchX)<35)return;const visible=slides.filter(s=>s.dataset.colour===colour),i=visible.findIndex(s=>s.dataset.imageId===selected);if(visible.length)show(visible[(i+(e.clientX<touchX?1:-1)+visible.length)%visible.length].dataset.imageId);touchX=undefined;});
  form.addEventListener('submit',async e=>{
   e.preventDefault();const button=form.querySelector('.lr-buy'),error=root.querySelector('.lr-cart-error');if(button.disabled)return;button.disabled=true;error.hidden=true;
   const items=[{id:Number(form.querySelector('[name="id"]').value),quantity:1},...[...root.querySelectorAll('[data-addon]:checked')].map(x=>({id:Number(x.value),quantity:1}))];
   let deferred,CartLinesUpdateEvent,added=false,redirecting=false;
   try{
    if(root.dataset.skipCart==='true'){
     const res=await fetch(root.dataset.addUrl+'.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items})});
     const result=await res.json();
     if(!res.ok){const failure=new Error(result.description||result.message);failure.lamierMessage=res.status===422?root.dataset.cartUnavailable:root.dataset.cartError;throw failure;}
     added=true;redirecting=true;
     location.assign(root.dataset.checkoutUrl);
     return;
    }
    ({CartLinesUpdateEvent}=await import('@shopify/events'));
    deferred=CartLinesUpdateEvent.createPromise();deferred.promise.catch(()=>{});
    root.dispatchEvent(new CartLinesUpdateEvent({action:'add',context:'product',lines:items.map(item=>({merchandiseId:String(item.id),quantity:item.quantity})),promise:deferred.promise}));
    const sections=[...document.querySelectorAll('cart-items-component')].map(el=>el.dataset.sectionId).filter(Boolean);
    const res=await fetch(root.dataset.addUrl+'.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items,sections:[...new Set(sections)].join(','),sections_url:location.pathname})});
    const result=await res.json();if(!res.ok){const failure=new Error(result.description||result.message);failure.lamierMessage=res.status===422?root.dataset.cartUnavailable:root.dataset.cartError;throw failure;}added=true;
    const cartResponse=await fetch(root.dataset.cartUrl+'.js',{headers:{'Accept':'application/json'}});
    if(!cartResponse.ok)throw new Error(root.dataset.cartUpdated);
    const cart=await cartResponse.json();
    deferred.resolve({cart:CartLinesUpdateEvent.createCartFromAjaxResponse(cart),detail:{items:cart.items,source:'product-form-component',sourceId:root.id,itemCount:items.length,productId:root.dataset.productId,sections:result.sections,didError:false}});
    document.querySelectorAll('.lr-cart b').forEach(el=>el.textContent=cart.item_count);
    if(!document.querySelector('#cart-drawer'))location.assign(root.dataset.cartUrl);
   }catch(err){redirecting=false;deferred?.reject(err);error.textContent=added?root.dataset.cartUpdated:(err.lamierMessage||root.dataset.cartError);error.hidden=false;}
   finally{if(!redirecting)button.disabled=false;}
  });
 });
}
initLamierProduct();
document.addEventListener('shopify:section:load',initLamierProduct);
window.addEventListener('pageshow',e=>{if(e.persisted)document.querySelectorAll('.lr-buy').forEach(button=>button.disabled=false);});
document.addEventListener('shopify:block:select',e=>{const slide=e.target.closest('.lr-slide');if(!slide)return;const root=slide.closest('.lr-main'),radio=[...root.querySelectorAll('.lr-variants input')].find(x=>x.dataset.title===slide.dataset.colour);if(radio&&!radio.checked){radio.checked=true;radio.dispatchEvent(new Event('change',{bubbles:true}));}root.querySelector('[data-thumbnail="'+slide.dataset.imageId+'"]').click();});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lamier-reference-quotes"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click',e=>{const b=e.target.closest('.lr-quote-nav button');if(!b)return;const root=b.closest('.lr-quotes-inner'),items=[...root.querySelectorAll('figure')],i=items.findIndex(x=>!x.hidden);const next=b.dataset.quoteIndex===undefined?(i+Number(b.dataset.step)+items.length)%items.length:Number(b.dataset.quoteIndex);items.forEach((x,n)=>x.hidden=n!==next);root.querySelectorAll('[data-quote-index]').forEach((x,n)=>x.setAttribute('aria-pressed',String(n===next)));});document.addEventListener('shopify:block:select',e=>{const item=e.target.closest('.lr-quotes figure');if(item)item.parentElement.querySelectorAll('figure').forEach(x=>x.hidden=x!==item);});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lamier-reference-reviews"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click',e=>{
 const expand=e.target.closest('[data-expand-review]');if(expand){const p=expand.closest('p');p.querySelector('[data-review-excerpt]').hidden=true;p.querySelector('[data-review-full]').hidden=false;expand.hidden=true;}
 const sort=e.target.closest('[data-review-sort]');
 if(sort){const list=sort.closest('.lr-reviews').querySelector('.lr-review-list'),items=[...list.children],mode=sort.dataset.reviewSort;items.sort((a,b)=>mode==='featured'?a.dataset.index-b.dataset.index:mode==='photos'?b.dataset.hasPhoto-a.dataset.hasPhoto:mode==='highest'?b.dataset.rating-a.dataset.rating:a.dataset.rating-b.dataset.rating).forEach(x=>list.append(x));sort.closest('details').open=false;}
 const photo=e.target.closest('[data-review-image]');
 if(photo){const dialog=photo.closest('.lr-reviews').querySelector('.lr-photo-dialog'),image=document.createElement('img');image.src=photo.dataset.reviewImage;image.alt=photo.getAttribute('aria-label');dialog.querySelector('[data-dialog-image]').replaceChildren(image);dialog.showModal();}
 const write=e.target.closest('[data-write-review]');if(write)write.closest('.lr-reviews').querySelector('.lr-review-dialog').showModal();
 if(e.target.closest('[data-close-dialog]'))e.target.closest('dialog').close();
 if(e.target.matches('.lr-photo-dialog,.lr-review-dialog')){const r=e.target.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)e.target.close();}
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lamier-reference-slider"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('input',event=>{if(event.target.matches('.lr-compare input'))event.target.parentElement.style.setProperty('--split',event.target.value+'%');});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
